import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightRegistrationFailedEventName = 'FREIGHT_REGISTRATION_FAILED';

export const useTrackFreightRegistrationFailed = (): ((reason: string) => void) => {
  return useCallback((reason: string) => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightRegistrationFailedEventName, { env: environment, reason });
  }, []);
};
